import React from 'react';
import classnames from 'classnames';
import styles from './featuredDataProvidersList.module.scss';

import { FeaturedDataProvider, RootState } from 'v2/models';

import { useSelector } from 'react-redux';
import { PERMISSION_NAME, getPermissionData } from 'v2/utils/permissions';
import QuestionMarkToolTip from 'v2/common/QuestionMarkToolTip/QuestionMarkToolTip';
import FeatureDataProviderCard from './FeatureDataProviderCard';

interface FeaturedDataProvidersListProps {
  list: FeaturedDataProvider[] | undefined;
}

const FeaturedDataProvidersList = ({
  list,
}: FeaturedDataProvidersListProps) => {
  const permissions = useSelector((state: RootState) => state.permissions);
  const searcherPermission = getPermissionData(permissions.permissions, [
    PERMISSION_NAME.CREATE_SEARCH,
  ]);

  const quantityRemaining = !searcherPermission[0]?.unlimited
    ? `(${searcherPermission[0]?.quantity_remaining} available)`
    : '';
  const helpText = `You can submit a maximum of ${searcherPermission[0]?.permission_quantity} requests at a time.`;

  return (
    <div className={classnames('position-relative', styles.tableContainer)}>
      <div>
        <div className={classnames(styles.tableHeader, styles.columnStyle)}>
          <p className="pr-1 pl-1">Data Category</p>
          <p className="pr-1 pl-1">Use Case Application</p>
          <div className={classnames('d-flex align-items-center')}>
            <p className="pr-1 pl-1">{`Requests ${quantityRemaining}`}</p>
            {!searcherPermission[0]?.unlimited && (
              <QuestionMarkToolTip styles={styles} helpText={helpText} />
            )}
          </div>
        </div>
        {!list?.length && (
          <div className={styles.NoDataContent}>
            <h1>No Featured Data Providers have been added yet!</h1>
          </div>
        )}
        {list?.map((item) => (
          <FeatureDataProviderCard item={item} key={item.id} />
        ))}
      </div>
    </div>
  );
};

export default FeaturedDataProvidersList;
